import { type AccountingSoftware } from 'modules/bookkeep/integration/status';

export function integrationSupportsReverseCharge(
  integration: AccountingSoftware,
): boolean {
  return [
    'Netsuite',
    'Sage100',
    'ACD',
    'Odoo',
    'SageIntacct',
    'MicrosoftDynamics',
    'ExactOnlineFr',
    'ExactOnlineBe',
    'ExactOnlineNl',
  ].includes(integration);
}
